import { graphql } from "../graphql";
import mutation from "./mutation.gql";
import { FetchResult } from "@apollo/client";
import { graphqlExtractGraphqlErrors } from "@/v2/util/graphql-extract-graphql-errors";
import { IRepoErrors } from "../errors";
import { graphqlRemapValidationErrors } from "@/v2/util/graphql-remap-validation-errors";
import {
  UserManagementTenantRoleEnum,
  UserManagementUserAccessTypeEnum,
} from "@/v2/enum/user-management";

export interface IRequestCreateInvite {
  organizationId: string;
  emails: Array<string>;
  role: UserManagementTenantRoleEnum;
  accessType: UserManagementUserAccessTypeEnum | null;
  accessIds: Array<string>;
}

export async function createInvite(
  request: IRequestCreateInvite
): Promise<Response> {
  let response: FetchResult<any, Record<string, any>, Record<string, any>>;
  const errors: IRepoErrors<ValidationErrors> = {};

  try {
    response = await graphql.mutate({
      mutation,
      variables: {
        organizationId: request.organizationId,
        emails: request.emails,
        role: request.role,
        accessType: request.accessType,
        accessIds: request.accessIds,
      },
    });
  } catch (error) {
    errors.networkError = true;
    throw new CreateInviteError(errors);
  }

  if (response.errors) {
    errors.graphqlError = graphqlExtractGraphqlErrors(response);
    errors.validationError = graphqlRemapValidationErrors(response);

    throw new CreateInviteError(errors);
  }

  return response.data.createInvite;
}

export class CreateInviteError extends Error {
  errors: IRepoErrors<ValidationErrors>;

  constructor(errors: IRepoErrors<ValidationErrors>) {
    super("Error in repo: createInviteError");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

type ValidationErrors = {};
